import { OrderStepType } from '../domain/order-entry.domain';
import { Strategy } from '../../domain/order.enum';

export interface HelpArticleIds {
  edit: string;
  review?: string;
  complete: string;
}

export abstract class TradingHelpContextService {

  private static readonly CANCEL_ARTICLES: Record<string, HelpArticleIds> = {
    OPTION: {
      edit: 'optn_ord_cancel',
      complete: 'optn_ord_cancel_received'
    },
    EQUITY: {
      edit: 'stck_ord_cancel',
      complete: 'stck_ord_cancel_received'
    }
  };

  private static readonly CHANGE_ARTICLES: Record<string, HelpArticleIds> = {
    OPTION: {
      edit: 'optn_ord_change',
      review: 'optn_ord_change_confirm',
      complete: 'optn_ord_change_received'
    },
    EQUITY: {
      edit: 'stck_ord_change',
      review: 'stck_ord_change_confirm',
      complete: 'stck_ord_change_received'
    }
  };

  private static readonly CREATE_ARTICLES: Record<string, HelpArticleIds> = {
    OPTION: {
      edit: 'optn_ord_enter',
      review: 'optn_ord_confirm',
      complete: 'optn_ord_received'
    },
    EQUITY: {
      edit: 'stck_ord_enter',
      review: 'stck_ord_confirm',
      complete: 'stck_ord_received'
    },
    MUTUALFUND: {
      edit: 'mfnd_ord_enter',
      review: 'mfnd_ord_confirm',
      complete: 'mfnd_ord_received'
    },
    HISA: {
      edit: 'hisa_ord_enter',
      review: 'hisa_ord_enter',
      complete: 'hisa_ord_enter'
    },
    GIC : {
      edit: 'gic_ord_land_page',
      review: 'gic_ord_review',
      complete: 'gic_ord_review'
    },
    STRATEGY : {
      edit: 'cmplx_land_page',
      review: 'cmplx_land_page',
      complete: 'cmplx_land_page'
    }
  };

  private static readonly STRATEGY_ARTICLES: Record<string, string> = {
    FTO: 'ftocmplx_land_page',
    MLO: 'mlocmplx_land_page',
    OCO: 'ococmplx_land_page',
    OTA: 'otacmplx_land_page'
  };

  private static readonly  COMPLEX_ARTICLE: string = 'cmplx_land_page';

  static getCancelArticleId(type: string, step: OrderStepType): string {
    return TradingHelpContextService.CANCEL_ARTICLES[type.toUpperCase()][step];
  }

  static getChangeArticleId(type: string, step: OrderStepType): string {
    return TradingHelpContextService.CHANGE_ARTICLES[type.toUpperCase()][step];
  }

  static getCreateArticleId(type: string, step: OrderStepType): string {
    return TradingHelpContextService.CREATE_ARTICLES[type.toUpperCase()][step];
  }

  static getStrategyArticleId(strategy?: Strategy): string {
    if (strategy === undefined) {
      return TradingHelpContextService.COMPLEX_ARTICLE;
    }
    return TradingHelpContextService.STRATEGY_ARTICLES[strategy];
  }
}
